import { RootStore, DateRange } from '../../../types';

export const selectCSRDateRange = (state: RootStore):DateRange | null =>
  state.statistics.CSR.dateRange;
